import { ISvgIconProps, } from './interface';
import { SvgIcon, } from './SvgIcon';

export const CheckIcon = (props: ISvgIconProps) => {
  return <SvgIcon {...props}>
    <polyline points="20 6 9 17 4 12"></polyline>
  </SvgIcon>;
};
